// components/BandeirasAceitas.jsx
import { Box, Typography } from "@mui/material";

// SVGs simplificados para as bandeiras
const BandeiraSVG = ({ tipo }) => {
  const svgs = {
    visa: (
      <svg width="40" height="25" viewBox="0 0 40 25">
        <rect width="40" height="25" fill="#1a1f71" rx="3" />
        <text x="20" y="16" fill="white" fontSize="10" textAnchor="middle" fontWeight="bold">VISA</text>
      </svg>
    ),
    mastercard: (
      <svg width="40" height="25" viewBox="0 0 40 25">
        <rect width="40" height="25" fill="#ff5f00" rx="3" />
        <circle cx="15" cy="12.5" r="6" fill="#eb001b" />
        <circle cx="25" cy="12.5" r="6" fill="#f79e1b" />
      </svg>
    ),
    amex: (
      <svg width="40" height="25" viewBox="0 0 40 25">
        <rect width="40" height="25" fill="#2e77bc" rx="3" />
        <text x="20" y="16" fill="white" fontSize="8" textAnchor="middle" fontWeight="bold">AMEX</text>
      </svg>
    ),
    hipercard: (
      <svg width="40" height="25" viewBox="0 0 40 25">
        <rect width="40" height="25" fill="#de1f27" rx="3" />
        <text x="20" y="16" fill="white" fontSize="7" textAnchor="middle" fontWeight="bold">HIPER</text>
      </svg>
    ),
    elo: (
      <svg width="40" height="25" viewBox="0 0 40 25">
        <rect width="40" height="25" fill="#211c18" rx="3" />
        <text x="20" y="16" fill="white" fontSize="10" textAnchor="middle" fontWeight="bold">ELO</text>
      </svg>
    )
  };

  return svgs[tipo] || null;
};

const BandeirasAceitas = () => {
  // const bandeiras = ['visa', 'mastercard', 'amex', 'hipercard', 'elo'];
  // Retirado ELO temporariamente
    const bandeiras = ['visa', 'mastercard', 'amex', 'hipercard'];

  return (
    <Box sx={{ mb: 2, p: 2, backgroundColor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
      <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1.5, color: '#495057' }}>
        💳 Bandeiras aceitas
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
        {bandeiras.map((bandeira) => (
          <Box
            key={bandeira}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '3px',
              overflow: 'hidden',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}
            title={bandeira.toUpperCase()}
          >
            <BandeiraSVG tipo={bandeira} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BandeirasAceitas;